'use strict'

class WebComponentAgreeButton extends HTMLElement {
  constructor() {
    super()
    const shadowRoot = this.attachShadow({ mode: 'open' })

    shadowRoot.innerHTML = `
      <link rel="stylesheet" href="https://classy.bankrate.com/1.0.3/css/classy.min.css">
      <link rel="stylesheet" href="https://use.typekit.net/aid8cmg.css">
      <div id="bankrateIncentive">
        <div class="page-wrapper +text-center">
          <label class="form-checkbox" id="briFauxBox">
            <input class="form-checkbox__input" type="checkbox" id="briCheckbox" />
            <span class="form-checkbox__faux-input icon">
              <svg class="icon__glyph" width="12" height="9" viewBox="0 0 12 9" fill-rule="evenodd">
                <path d="M4.1 6.1L1.4 3.4 0 4.9 4.1 9l7.6-7.6L10.3 0z"></path>
              </svg>
            </span>
            <span class="+leading-none +text-left" id="checkboxText"></span>
          </label>
          <button id="briButton" class="button --primary --is-disabled +mg-top-sm" type="button" disabled></button>
        </div>
      </div>
    `

    this.checkbox = shadowRoot.querySelector('#briCheckbox')
    this.isChecked = false
    this.fauxBox = shadowRoot.querySelector('#briFauxBox')
    this.checkboxText = shadowRoot.querySelector('#checkboxText')
    this.button = shadowRoot.querySelector('#briButton')
    this.goToUrl = this.getAttribute('href')
    this.search = window.location.search
    this.tagular = window.tagular || function() {}
    this.tagularLocation = ''
    this.tagularOutcome = ''
    this.uuid = ''
    this.alternateStyle = shadowRoot.querySelector('#bankrateIncentive')

    this.fauxBox.addEventListener('click', this.checkboxEvent.bind(this), true)
    this.button.addEventListener('click', this.buttonEvent.bind(this))
  }

  static get observedAttributes() {
    return [
      'checkbox-text',
      'button-text',
      'tagular-location',
      'tagular-outcome',
      'alternate-style'
    ]
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'checkbox-text':
        this.checkboxText.textContent = newValue || ''
        break
      case 'button-text':
        this.button.textContent = newValue || ''
        break
      case 'tagular-location':
        this.tagularLocation = newValue || ''
        break
      case 'tagular-outcome':
        this.tagularOutcome = newValue || ''
        break
      case 'alternate-style':
        this.alternateStyle.style = newValue || ''
        break
    }
  }

  generateUUID() {
    return (
      Math.round(Math.random() * 10000000).toString() + new Date().getTime()
    )
  }

  checkboxEvent(event) {
    event.stopPropagation()
    event.preventDefault()

    this.isChecked = !this.isChecked

    if (this.isChecked) {
      this.uuid = this.generateUUID()

      this.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          elementType: 'Checkbox',
          location: this.tagularLocation,
          position: '',
          htmlId: '',
          text: this.checkboxText.textContent
        },
        actionOutcome: 'checkbox checked',
        correlationId: this.uuid
      })
      this.button.disabled = false
      this.button.classList.remove('--is-disabled')
    } else {
      this.button.disabled = true
      this.button.classList.add('--is-disabled')
    }

    this.checkbox.checked = this.isChecked
  }

  buttonEvent(event) {
    event.preventDefault()
    if (this.checkbox.checked) {
      this.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          elementType: 'Button',
          location: this.tagularLocation,
          position: '',
          htmlId: '',
          text: this.button.textContent
        },
        actionOutcome: this.tagularOutcome,
        correlationId: this.uuid
      })
      window.location = this.goToUrl + this.search
    }
  }
}

window.customElements.define('agree-button', WebComponentAgreeButton)
